module.exports = __webpack_public_path__ + "img/cloud-wind-2-sun-2.115f746b.svg";